import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { Kosa } from '../types/kosa';
import { KosaService } from '../http/kosa-service';

export default class KosaStore {
    private _nodeId: number;
    private _loading = false;
    private _items: Kosa[] = [];

    constructor(nodeId: number = 0) {
        this._nodeId = nodeId;
        makeObservable<KosaStore, '_loading' | '_items'>(this, {
            _loading: observable,
            _items: observable,
            loading: computed,
            items: computed,
            load: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get items(): Kosa[] {
        return this._items;
    }

    async load(): Promise<void> {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await KosaService.allByNode(this._nodeId);
            runInAction(() => {
                this._items = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }
}
